<template>
   <ContactSalesPopup
      @close="toggleContactSales"
      :contactSalesActive="contactSalesActive"
      class="overflow-y-hidden"
   >
   </ContactSalesPopup>
   <EmailGrabberPopup
      @close="toggleGrabber"
      :grabberActive="grabberActive"
      :freePlan="freePlan"
      :payPlan="payPlan"
      :planId="planId"
      class="overflow-y-hidden"
   >
   </EmailGrabberPopup>
   <header
      id="header"
      class="header ease fixed top-0 z-30 w-full transition-all duration-500"
      @click="resetTab"
   >
      <!-- products desktop menu  -->
      <transition name="desktop-animation">
         <div
            id="productNavDesktop product_nav_desktop "
            class="product-nav-desktop w-full h-[600px] pt-[100px] -z-10 absolute bg-white"
            v-on:mouseleave="toggleTabs(0)"
            v-show="openTab === 1"
         >
            <transition name="desktop-menu-list">
               <div
                  v-show="openTab === 1"
                  class="desktop-nav-menu-animation w-full border-t border-[#E3E3E3]"
               >
                  <div class="w-[1232px] h-[400px] flex mx-auto">
                     <!-- product -->
                     <div
                        class="mx-[6px] w-[727px] border-r border-[#E3E3E3] pl-[16px] pr-[6px]"
                     >
                        <h4
                           class="mt-10 mb-[25px] text-[#292d34] text-sm font-semibold"
                        >
                           PRODUCT
                        </h4>

                        <ul
                           class="product-row-one flex grid-rows-2 grid-flow-row gap-[6px] mb-[15px] ease-in-out duration-700 delay-1000"
                        >
                           <transition name="desktop-menu-item">
                              <Link href="/online-courses">
                                 <li
                                    v-show="openTab === 1"
                                    class="cursor-pointer w-[234px] h-[98px] rounded-[15px] px-[18px] py-[15px] hover:bg-[#00b88415] flex"
                                 >
                                    <div class="mr-[14px]">
                                       <img
                                          class="w-[37px] h-[31px]"
                                          :src="
                                             $filters.media_path(
                                                '/images/nav-courses-green-icon.svg'
                                             )
                                          "
                                          alt="Platforma online courses"
                                       />
                                    </div>
                                    <div>
                                       <h6
                                          class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                       >
                                          Online Courses
                                       </h6>
                                       <h6
                                          class="text-[#292d34] text-xs font-base"
                                       >
                                          The Greatest Course Builder Available.
                                       </h6>
                                    </div>
                                 </li>
                              </Link>
                           </transition>
                           <transition name="desktop-menu-item">
                              <Link href="/coaching ">
                                 <li
                                    v-show="openTab === 1"
                                    class="ease-in cursor-pointer w-[234px] h-[98px] rounded-[15px] px-[18px] py-[15px] hover:bg-[#FFC80015] flex"
                                 >
                                    <div class="mr-[14px]">
                                       <img
                                          class="w-[37px] h-[37px]"
                                          :src="
                                             $filters.media_path(
                                                '/images/nav-coaching-yellow-icon.svg'
                                             )
                                          "
                                          alt="Platforma online courses"
                                       />
                                    </div>
                                    <div>
                                       <h6
                                          class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                       >
                                          Coaching
                                       </h6>
                                       <h6
                                          class="text-[#292d34] text-xs font-base"
                                       >
                                          The Greatest Coaching Service
                                          Available.
                                       </h6>
                                    </div>
                                 </li>
                              </Link>
                           </transition>
                           <transition name="desktop-menu-item">
                              <Link href="/live-streaming-webinars">
                                 <li
                                    v-show="openTab === 1"
                                    class="cursor-pointer w-[234px] h-[98px] rounded-[15px] px-[18px] py-[15px] hover:bg-[#9146FF15] flex"
                                 >
                                    <div class="mr-[14px]">
                                       <img
                                          class="w-[31px] h-[35px]"
                                          :src="
                                             $filters.media_path(
                                                '/images/nav-live-webinars-purple-icon.svg'
                                             )
                                          "
                                          alt="Platforma online courses"
                                       />
                                    </div>
                                    <div>
                                       <h6
                                          class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                       >
                                          Live Streaming
                                       </h6>
                                       <h6
                                          class="text-[#292d34] text-xs font-base"
                                       >
                                          Better than Twitch and WebinarJam
                                          COMBINED.
                                       </h6>
                                    </div>
                                 </li>
                              </Link>
                           </transition>
                        </ul>
                        <ul
                           class="product-row-two flex grid-rows-2 grid-flow-row gap-[6px]"
                        >
                           <transition name="desktop-menu-item">
                              <Link href="/group-newsfeed">
                                 <li
                                    v-show="openTab === 1"
                                    class="cursor-pointer w-[234px] h-[98px] rounded-[15px] px-[18px] py-[15px] hover:bg-[#67B7F915] flex"
                                 >
                                    <div class="mr-[14px]">
                                       <img
                                          class="w-[47px] h-[41px]"
                                          :src="
                                             $filters.media_path(
                                                '/images/nav-live-newsfeeds-blue-icon.svg'
                                             )
                                          "
                                          alt="Platforma online courses"
                                       />
                                    </div>
                                    <div>
                                       <h6
                                          class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                       >
                                          Group Newsfeeds
                                       </h6>
                                       <h6
                                          class="text-[#292d34] text-xs font-base"
                                       >
                                          Move Your Facebook Group To A Private
                                          Place.
                                       </h6>
                                    </div>
                                 </li>
                              </Link>
                           </transition>
                           <transition name="desktop-menu-item">
                              <Link href="/video-channels">
                                 <li
                                    v-show="openTab === 1"
                                    class="cursor-pointer w-[234px] h-[98px] rounded-[15px] px-[18px] py-[15px] hover:bg-[#CD201F15] flex"
                                 >
                                    <div class="mr-[14px]">
                                       <img
                                          class="w-[27px] h-[27px]"
                                          :src="
                                             $filters.media_path(
                                                '/images/nav-live-channels-red-icon.svg'
                                             )
                                          "
                                          alt="Platforma online courses"
                                       />
                                    </div>
                                    <div>
                                       <h6
                                          class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                       >
                                          Video Channels
                                       </h6>
                                       <h6
                                          class="text-[#292d34] text-xs font-base"
                                       >
                                          Never Be De-monetized Again.
                                       </h6>
                                    </div>
                                 </li>
                              </Link>
                           </transition>
                           <transition name="desktop-menu-item">
                              <Link href="/quizzes">
                                 <li
                                    v-show="openTab === 1"
                                    class="cursor-pointer w-[234px] h-[98px] rounded-[15px] px-[18px] py-[15px] hover:bg-[#49CCF915] flex"
                                 >
                                    <div class="mr-[14px]">
                                       <img
                                          class="w-[41px] h-[45px]"
                                          :src="
                                             $filters.media_path(
                                                '/images/nav-live-quizzes-light-blue-icon.svg'
                                             )
                                          "
                                          alt="Platforma online courses"
                                       />
                                    </div>
                                    <div>
                                       <h6
                                          class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                       >
                                          Quizzes
                                       </h6>
                                       <h6
                                          class="text-[#292d34] text-xs font-base"
                                       >
                                          Test Your Member’s Skills with
                                          advanced coaching.
                                       </h6>
                                    </div>
                                 </li>
                              </Link>
                           </transition>
                        </ul>
                     </div>
                     <!-- platform -->
                     <div>
                        <h4
                           class="mt-10 mb-[25px] ml-4 text-[#292d34] text-sm font-semibold"
                        >
                           PLATFORM
                        </h4>
                        <ul
                           class="product-row-one flex grid-rows-2 grid-flow-row gap-[6px] mb-[15px]"
                        >
                           <transition name="desktop-menu-item">
                              <Link href="/make-money-online">
                                 <li
                                    v-show="openTab === 1"
                                    class="cursor-pointer w-[234px] h-[98px] rounded-[15px] px-[18px] py-[15px] hover:bg-[#00B88415] flex"
                                 >
                                    <div class="mr-[14px]">
                                       <img
                                          class="w-[37px] h-[31px]"
                                          :src="
                                             $filters.media_path(
                                                '/images/nav-monetize-green-icon.svg'
                                             )
                                          "
                                          alt="Platforma online courses"
                                       />
                                    </div>
                                    <div>
                                       <h6
                                          class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                       >
                                          Flexible Monetization
                                       </h6>
                                       <h6
                                          class="text-[#292d34] text-xs font-base"
                                       >
                                          Hundreds of ways to monetize your
                                          audience
                                       </h6>
                                    </div>
                                 </li>
                              </Link>
                           </transition>
                           <transition name="desktop-menu-item">
                              <Link href="/custom-domains">
                                 <li
                                    v-show="openTab === 1"
                                    class="cursor-pointer w-[234px] h-[98px] rounded-[15px] px-[18px] py-[15px] hover:bg-[#B46D2A15] flex"
                                 >
                                    <div class="mr-[14px]">
                                       <img
                                          class="w-[37px] h-[37px]"
                                          :src="
                                             $filters.media_path(
                                                '/images/nav-domains-brown-icon.svg'
                                             )
                                          "
                                          alt="Platforma online courses"
                                       />
                                    </div>
                                    <div>
                                       <h6
                                          class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                       >
                                          Custom Domains
                                       </h6>
                                       <h6
                                          class="text-[#292d34] text-xs font-base"
                                       >
                                          Whitelabel your own community and
                                          guidleines
                                       </h6>
                                    </div>
                                 </li>
                              </Link>
                           </transition>
                        </ul>
                        <ul
                           class="product-row-two flex grid-rows-2 grid-flow-row gap-[6px]"
                        >
                           <transition name="desktop-menu-item">
                              <Link href="/integrations">
                                 <li
                                    v-show="openTab === 1"
                                    class="cursor-pointer w-[234px] h-[98px] rounded-[15px] px-[18px] py-[15px] hover:bg-[#FF990015] flex"
                                 >
                                    <div class="mr-[14px]">
                                       <img
                                          class="w-[27px] h-[27px]"
                                          :src="
                                             $filters.media_path(
                                                '/images/nav-integrations-orange-icon.svg'
                                             )
                                          "
                                          alt="Platforma online courses"
                                       />
                                    </div>
                                    <div>
                                       <h6
                                          class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                       >
                                          Integrations
                                       </h6>
                                       <h6
                                          class="text-[#292d34] text-xs font-base"
                                       >
                                          Integrate with your favorite tools.
                                       </h6>
                                    </div>
                                 </li>
                              </Link>
                           </transition>
                           <transition name="desktop-menu-item">
                              <Link href="member-data">
                                 <li
                                    v-show="openTab === 1"
                                    class="cursor-pointer w-[234px] h-[98px] rounded-[15px] px-[18px] py-[15px] hover:bg-[#BB66E115] flex"
                                 >
                                    <div class="mr-[14px]">
                                       <img
                                          class="w-[47px] h-[47px]"
                                          :src="
                                             $filters.media_path(
                                                '/images/nav-member-data-purple-icon.svg'
                                             )
                                          "
                                          alt="Platforma online courses"
                                       />
                                    </div>
                                    <div>
                                       <h6
                                          class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                       >
                                          Member Data
                                       </h6>
                                       <h6
                                          class="text-[#292d34] text-xs font-base"
                                       >
                                          Own the member data that you have
                                          earned.
                                       </h6>
                                    </div>
                                 </li>
                              </Link>
                           </transition>
                        </ul>
                     </div>
                  </div>
                  <!-- contact -->
                  <div
                     class="w-full h-[100px] mb-0 border-t border-[#E3E3E3] shadow-[0_35px_35px_rgba(0,0,0,0.10)]"
                  >
                     <div class="w-[1232px] mx-auto my-auto pl-4">
                        <transition name="desktop-menu-item">
                           <div
                              v-show="openTab === 1"
                              class="cursor-pointer w-[375px] h-[80px] mt-[10px] rounded-[15px] px-[19px] py-[16px] hover:bg-[#2D8CFF15] flex"
                           >
                              <div class="mr-[14px]">
                                 <img
                                    class="w-[36px] h-[36px]"
                                    :src="
                                       $filters.media_path(
                                          '/images/nav-contact-us-blue-icon.svg'
                                       )
                                    "
                                    alt="Platforma online courses"
                                 />
                              </div>
                              <div @click="toggleContactSales">
                                 <h6
                                    class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                 >
                                    Contact Us
                                 </h6>
                                 <h6
                                    class="text-[#292d34] text-[11px] font-base"
                                 >
                                    Get in touch with our 24/7 live support team
                                    for free
                                 </h6>
                              </div>
                           </div>
                        </transition>
                     </div>
                  </div>
               </div>
            </transition>
         </div>
      </transition>
      <!-- solutions desktop menu -->
      <transition name="desktop-animation">
         <div
            id="solutionsNavDesktop solutions_nav_desktop"
            class="solutions_nav_desktop w-full h-[600px] pt-[100px] -z-10 absolute bg-white"
            v-on:mouseleave="toggleTabs(0)"
            v-show="openTab === 2"
         >
            <transition name="desktop-menu-list">
               <div v-show="openTab === 2" class="border-t border-[#E3E3E3]">
                  <div class="w-[1232px] h-[400px] flex mx-auto">
                     <!-- who creates -->
                     <div
                        class="mx-[6px] w-[727px] border-r border-[#E3E3E3] pl-[16px] pr-[6px]"
                     >
                        <h4
                           class="mt-10 mb-[25px] text-[#292d34] text-sm font-semibold"
                        >
                           WHO CREATES PLATFORMS
                        </h4>
                        <ul
                           class="product-row-one flex grid-rows-2 grid-flow-row gap-[6px] mb-[15px]"
                        >
                           <Link href="/course-creators">
                              <li
                                 class="cursor-pointer w-[234px] h-[98px] rounded-[15px] px-[18px] py-[15px] hover:bg-[#2D8CFF15] flex"
                              >
                                 <div class="mr-[14px]">
                                    <img
                                       class="w-[37px] h-[31px]"
                                       :src="
                                          $filters.media_path(
                                             '/images/nav-course-creators-blue-icon.svg'
                                          )
                                       "
                                       alt="Platforma online courses"
                                    />
                                 </div>
                                 <div>
                                    <h6
                                       class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                    >
                                       Course Creators
                                    </h6>
                                    <h6
                                       class="text-[#292d34] text-xs font-base"
                                    >
                                       Best Place to build and Host your course.
                                    </h6>
                                 </div>
                              </li>
                           </Link>
                           <Link href="/influencers">
                              <li
                                 class="cursor-pointer w-[234px] h-[98px] rounded-[15px] px-[18px] py-[15px] hover:bg-[#2D8CFF15] flex"
                              >
                                 <div class="mr-[14px]">
                                    <img
                                       class="w-[37px] h-[37px]"
                                       :src="
                                          $filters.media_path(
                                             '/images/nav-influencers-blue-icon.svg'
                                          )
                                       "
                                       alt="Platforma online courses"
                                    />
                                 </div>
                                 <div>
                                    <h6
                                       class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                    >
                                       Influencers
                                    </h6>
                                    <h6
                                       class="text-[#292d34] text-xs font-base"
                                    >
                                       Create additional source of revenue.
                                    </h6>
                                 </div>
                              </li>
                           </Link>
                           <Link href="/consultants">
                              <li
                                 class="cursor-pointer w-[234px] h-[98px] rounded-[15px] px-[18px] py-[15px] hover:bg-[#2D8CFF15] flex"
                              >
                                 <div class="mr-[14px]">
                                    <img
                                       class="w-[41px] h-[41px]"
                                       :src="
                                          $filters.media_path(
                                             '/images/nav-consultants-blue-icon.svg'
                                          )
                                       "
                                       alt="Platforma online courses"
                                    />
                                 </div>
                                 <div>
                                    <h6
                                       class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                    >
                                       Consultants
                                    </h6>
                                    <h6
                                       class="text-[#292d34] text-xs font-base"
                                    >
                                       Interact 1-on-1 and serve your client
                                       base.
                                    </h6>
                                 </div>
                              </li>
                           </Link>
                        </ul>
                        <ul
                           class="product-row-two flex grid-rows-2 grid-flow-row gap-[6px]"
                        >
                           <Link href="/coaches">
                              <li
                                 class="cursor-pointer w-[234px] h-[98px] rounded-[15px] px-[18px] py-[15px] hover:bg-[#2D8CFF15] flex"
                              >
                                 <div class="mr-[14px]">
                                    <img
                                       class="w-[47px] h-[41px]"
                                       :src="
                                          $filters.media_path(
                                             '/images/nav-coaches-blue-icon.svg'
                                          )
                                       "
                                       alt="Platforma online courses"
                                    />
                                 </div>
                                 <div>
                                    <h6
                                       class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                    >
                                       Coaches
                                    </h6>
                                    <h6
                                       class="text-[#292d34] text-xs font-base"
                                    >
                                       Coach health, life, or anything and get
                                       results fast.
                                    </h6>
                                 </div>
                              </li>
                           </Link>
                           <Link href="/podcasters">
                              <li
                                 class="cursor-pointer w-[234px] h-[98px] rounded-[15px] px-[18px] py-[15px] hover:bg-[#2D8CFF15] flex"
                              >
                                 <div class="mr-[14px]">
                                    <img
                                       class="w-[37px] h-[37px]"
                                       :src="
                                          $filters.media_path(
                                             '/images/nav-podcasters-blue-icon.svg'
                                          )
                                       "
                                       alt="Platforma online courses"
                                    />
                                 </div>
                                 <div>
                                    <h6
                                       class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                    >
                                       Podcasters
                                    </h6>
                                    <h6
                                       class="text-[#292d34] text-xs font-base"
                                    >
                                       Host your podcasts on your own website
                                       and domain.
                                    </h6>
                                 </div>
                              </li>
                           </Link>
                           <Link href="/video-creators">
                              <li
                                 class="cursor-pointer w-[234px] h-[98px] rounded-[15px] px-[18px] py-[15px] hover:bg-[#2D8CFF15] flex"
                              >
                                 <div class="mr-[14px]">
                                    <img
                                       class="w-[41px] h-[45px]"
                                       :src="
                                          $filters.media_path(
                                             '/images/nav-video-creators-blue-icon.svg'
                                          )
                                       "
                                       alt="Platforma online courses"
                                    />
                                 </div>
                                 <div>
                                    <h6
                                       class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                    >
                                       Video Creators
                                    </h6>
                                    <h6
                                       class="text-[#292d34] text-xs font-base"
                                    >
                                       Backup, protect, and host all your
                                       valuable assets.
                                    </h6>
                                 </div>
                              </li>
                           </Link>
                        </ul>
                     </div>
                     <!-- use cases -->
                     <div>
                        <h4
                           class="mt-10 mb-[25px] ml-4 text-[#292d34] text-sm font-semibold"
                        >
                           USE CASES
                        </h4>
                        <ul
                           class="product-row-one flex grid-rows-2 grid-flow-row gap-[6px] mb-[15px]"
                        >
                           <Link href="/membership-sites">
                              <li
                                 class="cursor-pointer w-[234px] h-[98px] rounded-[15px] px-[18px] py-[15px] hover:bg-[#68EEBE15] flex"
                              >
                                 <div class="mr-[14px]">
                                    <img
                                       l
                                       class="w-[37px] h-[31px]"
                                       :src="
                                          $filters.media_path(
                                             '/images/nav-membership-sites-green-icon.svg'
                                          )
                                       "
                                       alt="Platforma online courses"
                                    />
                                 </div>
                                 <div>
                                    <h6
                                       class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                    >
                                       Membership Site
                                    </h6>
                                    <h6
                                       class="text-[#292d34] text-xs font-base"
                                    >
                                       Create a private VIP Members area to
                                       monetize.
                                    </h6>
                                 </div>
                              </li>
                           </Link>
                           <Link href="/programs-and-courses">
                              <li
                                 class="cursor-pointer w-[234px] h-[98px] rounded-[15px] px-[18px] py-[15px] hover:bg-[#68EEBE15] flex"
                              >
                                 <div class="mr-[14px]">
                                    <img
                                       class="w-[47px] h-[47px]"
                                       :src="
                                          $filters.media_path(
                                             '/images/nav-programs-courses-green-icon.svg'
                                          )
                                       "
                                       alt="Platforma online courses"
                                    />
                                 </div>
                                 <div>
                                    <h6
                                       class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                    >
                                       Programs & Courses
                                    </h6>
                                    <h6
                                       class="text-[#292d34] text-xs font-base"
                                    >
                                       Sell and upsell all your courses in one
                                       place, with one login.
                                    </h6>
                                 </div>
                              </li>
                           </Link>
                        </ul>
                        <ul
                           class="product-row-two flex grid-rows-2 grid-flow-row gap-[6px]"
                        >
                           <Link href="online-communities">
                              <li
                                 class="cursor-pointer w-[234px] h-[98px] rounded-[15px] px-[18px] py-[15px] hover:bg-[#68EEBE15] flex"
                              >
                                 <div class="mr-[14px]">
                                    <img
                                       class="w-[47px] h-[47px]"
                                       :src="
                                          $filters.media_path(
                                             '/images/nav-community-green-icon.svg'
                                          )
                                       "
                                       alt="Platforma online courses"
                                    />
                                 </div>
                                 <div>
                                    <h6
                                       class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                    >
                                       Community
                                    </h6>
                                    <h6
                                       class="text-[#292d34] text-xs font-base"
                                    >
                                       Give your audience and official homebase
                                       to congregate.
                                    </h6>
                                 </div>
                              </li>
                           </Link>
                           <Link href="/leads-and-sales">
                              <li
                                 class="cursor-pointer w-[234px] h-[98px] rounded-[15px] px-[18px] py-[15px] hover:bg-[#68EEBE15] flex"
                              >
                                 <div class="mr-[14px]">
                                    <img
                                       class="w-[57px] h-[57px]"
                                       :src="
                                          $filters.media_path(
                                             '/images/nav-lead-nurture-green-icon.svg'
                                          )
                                       "
                                       alt="Platforma online courses"
                                    />
                                 </div>
                                 <div>
                                    <h6
                                       class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                    >
                                       Lead Nurture & Sales
                                    </h6>
                                    <h6
                                       class="text-[#292d34] text-xs font-base"
                                    >
                                       Funnel all your leads into one place to
                                       convert to paying customers.
                                    </h6>
                                 </div>
                              </li>
                           </Link>
                        </ul>
                     </div>
                  </div>
                  <!-- contact -->
                  <transition name="desktop-nav-menu-animation">
                     <div
                        class="w-full h-[100px] mb-0 border-t border-[#E3E3E3] shadow-[0_35px_35px_rgba(0,0,0,0.10)]"
                     >
                        <div class="w-[1232px] mx-auto my-auto pl-4">
                           <div
                              class="cursor-pointer w-[375px] h-[80px] mt-[10px] rounded-[15px] px-[19px] py-[16px] hover:bg-[#2D8CFF15] flex"
                           >
                              <div class="mr-[14px]">
                                 <img
                                    class="w-[36px] h-[36px]"
                                    :src="
                                       $filters.media_path(
                                          '/images/nav-contact-us-blue-icon.svg'
                                       )
                                    "
                                    alt="Platforma online courses"
                                 />
                              </div>
                              <div @click="toggleContactSales">
                                 <h6
                                    class="text-[#292d34] text-sm font-semibold mb-[6px]"
                                 >
                                    Contact Us
                                 </h6>
                                 <h6
                                    class="text-[#292d34] text-[11px] font-base"
                                 >
                                    Get in touch with our 24/7 live support team
                                    for free
                                 </h6>
                              </div>
                           </div>
                        </div>
                     </div>
                  </transition>
               </div>
            </transition>
         </div>
      </transition>
      <!-- mobile nav -->
      <transition name="mobile-animation">
         <div
            v-if="toggleMobileNav"
            class="w-full h-screen bg-black bg-opacity-50 z-40 absolute lg:hidden"
         >
            <nav
               v-show="toggleMobileNav"
               class="mobile-nav mobile-animation bg-white w-full h-[590px] lg:hidden px-[25px] pt-[35px] pb-[25px] right-0 z-50 shadow-2xl absolute overflow-y-scroll overflow-hidden"
            >
               <div
                  class="mobile-nav-header-with-close justify-between flex mb-8 max-w-[600px] mx-auto"
                  @click="resetTabM"
               >
                  <!-- logo -->
                  <Link href="/">
                     <img
                        class="h-8"
                        :src="
                           $filters.media_path(
                              'images/platforma-logo-in-color.svg'
                           )
                        "
                        alt="Platforma Online Course Builder Header Logo"
                     />
                  </Link>
                  <!-- mobile icon -->
                  <img
                     class="w-5 h-5 cursor-pointer"
                     :src="$filters.media_path('images/mobile-nav-close.svg')"
                     alt="Platforma close navigation"
                  />
               </div>
               <ul class="max-w-[600px] mx-auto">
                  <li
                     @click="
                        (openProductMobileMenu = !openProductMobileMenu),
                           !openSolutionsMobileMenu
                     "
                     class="justify-between flex mb-8 cursor-pointer"
                  >
                     <button class="text-[#292d34] font-bold text-lg">
                        Product
                     </button>

                     <img
                        v-if="!openProductMobileMenu"
                        class="w-[10px]"
                        :src="
                           $filters.media_path(
                              'images/mobile-nav-right-dropdown-chevron-grey.svg'
                           )
                        "
                        alt="Platforma dropdown"
                     />
                     <img
                        v-if="openProductMobileMenu"
                        class="w-[16px]"
                        :src="
                           $filters.media_path(
                              'images/mobile-nav-down-dropdown-chevron-blue.svg'
                           )
                        "
                        alt="Platforma dropdown"
                     />
                  </li>
                  <!-- Products Dropdown Menu - Mobile -->
                  <transition name="mobile-dropdown-animation">
                     <div v-if="openProductMobileMenu" @click="resetTabM">
                        <ul class="mb-[44px]">
                           <li
                              class="flex border-b-2 border-[#F0F0F0] py-5 h-16"
                           >
                              <img
                                 class="w-[26px] mr-3"
                                 :src="
                                    $filters.media_path(
                                       'images/nav-courses-green-icon.svg'
                                    )
                                 "
                                 alt="Platforma dropdown"
                              />

                              <Link
                                 href="/online-courses"
                                 class="text-[#292d34] font-bold text-sm w-full cursor-pointer"
                                 >Online Courses</Link
                              >
                           </li>
                           <li
                              class="flex border-b-2 border-[#F0F0F0] py-5 h-16"
                           >
                              <img
                                 class="w-[26px] mr-3"
                                 :src="
                                    $filters.media_path(
                                       'images/nav-coaching-yellow-icon.svg'
                                    )
                                 "
                                 alt="Platforma dropdown"
                              />

                              <Link
                                 href="/coaching"
                                 class="text-[#292d34] font-bold text-sm w-full cursor-pointer"
                                 >Coaching</Link
                              >
                           </li>
                           <li
                              class="flex border-b-2 border-[#F0F0F0] py-5 h-16"
                           >
                              <img
                                 class="w-[26px] mr-3"
                                 :src="
                                    $filters.media_path(
                                       'images/nav-live-webinars-purple-icon.svg'
                                    )
                                 "
                                 alt="Platforma dropdown"
                              />

                              <Link
                                 href="/live-streaming-webinars"
                                 class="text-[#292d34] font-bold text-sm w-full cursor-pointer"
                                 >Live Streaming Webinars</Link
                              >
                           </li>
                           <li
                              class="flex border-b-2 border-[#F0F0F0] py-5 h-16"
                           >
                              <img
                                 class="w-[26px] mr-3"
                                 :src="
                                    $filters.media_path(
                                       'images/nav-live-newsfeeds-blue-icon.svg'
                                    )
                                 "
                                 alt="Platforma dropdown"
                              />

                              <Link
                                 href="/group-newsfeed"
                                 class="text-[#292d34] font-bold text-sm w-full cursor-pointer"
                                 >Group Newsfeeds</Link
                              >
                           </li>
                           <li
                              class="flex border-b-2 border-[#F0F0F0] py-5 h-16"
                           >
                              <img
                                 class="w-[26px] mr-3"
                                 :src="
                                    $filters.media_path(
                                       'images/nav-live-channels-red-icon.svg'
                                    )
                                 "
                                 alt="Platforma dropdown"
                              />

                              <Link
                                 href="/video-channels"
                                 class="text-[#292d34] font-bold text-sm w-full cursor-pointer"
                                 >Video Channels</Link
                              >
                           </li>
                           <li
                              class="flex border-b-2 border-[#F0F0F0] py-5 h-16"
                           >
                              <img
                                 class="w-[26px] mr-3"
                                 :src="
                                    $filters.media_path(
                                       'images/nav-live-quizzes-light-blue-icon.svg'
                                    )
                                 "
                                 alt="Platforma dropdown"
                              />

                              <Link
                                 href="/quizzes"
                                 class="text-[#292d34] font-bold text-sm w-full cursor-pointer"
                                 >Quizzes</Link
                              >
                           </li>
                        </ul>
                        <!-- Platform List 2 -->
                        <a
                           class="text-[#292d34] font-bold text-sm mt-[50px] py-5"
                           >PLATFORM</a
                        >

                        <ul class="mb-[44px]">
                           <li
                              class="flex border-b-2 border-[#F0F0F0] py-5 mt-5 h-16"
                           >
                              <img
                                 class="w-[26px] mr-3"
                                 :src="
                                    $filters.media_path(
                                       'images/nav-monetize-green-icon.svg'
                                    )
                                 "
                                 alt="Platforma dropdown"
                              />

                              <Link
                                 href="/make-money-online"
                                 class="text-[#292d34] font-bold text-sm w-full cursor-pointer"
                                 >Flexible Monetization</Link
                              >
                           </li>
                           <li
                              class="flex border-b-2 border-[#F0F0F0] py-5 h-16"
                           >
                              <img
                                 class="w-[26px] mr-3"
                                 :src="
                                    $filters.media_path(
                                       'images/nav-domains-brown-icon.svg'
                                    )
                                 "
                                 alt="Platforma dropdown"
                              />

                              <Link
                                 href="/custom-domains"
                                 class="text-[#292d34] font-bold text-sm w-full cursor-pointer"
                                 >Custom Domains</Link
                              >
                           </li>
                           <li
                              class="flex border-b-2 border-[#F0F0F0] py-5 h-16"
                           >
                              <img
                                 class="w-[26px] mr-3"
                                 :src="
                                    $filters.media_path(
                                       'images/nav-integrations-orange-icon.svg'
                                    )
                                 "
                                 alt="Platforma dropdown"
                              />

                              <Link
                                 href="/integrations"
                                 class="text-[#292d34] font-bold text-sm w-full cursor-pointer"
                                 >Integrations</Link
                              >
                           </li>
                           <li
                              class="flex border-b-2 border-[#F0F0F0] py-5 h-16"
                           >
                              <img
                                 class="w-[26px] mr-3"
                                 :src="
                                    $filters.media_path(
                                       'images/nav-member-data-purple-icon.svg'
                                    )
                                 "
                                 alt="Platforma dropdown"
                              />

                              <Link
                                 href="member-data"
                                 class="text-[#292d34] font-bold text-sm w-full cursor-pointer"
                                 >Member Data</Link
                              >
                           </li>
                        </ul>
                     </div>
                  </transition>
                  <!-- Solutions Dropdown -->
                  <li
                     @click="openSolutionsMobileMenu = !openSolutionsMobileMenu"
                     class="justify-between flex mb-8 w-full cursor-pointer"
                  >
                     <button class="text-[#292d34] font-bold text-lg">
                        Solutions
                     </button>

                     <img
                        v-if="!openSolutionsMobileMenu"
                        class="w-[10px]"
                        :src="
                           $filters.media_path(
                              'images/mobile-nav-right-dropdown-chevron-grey.svg'
                           )
                        "
                        alt="Platforma dropdown"
                     />
                     <img
                        v-if="openSolutionsMobileMenu"
                        class="w-[16px]"
                        :src="
                           $filters.media_path(
                              'images/mobile-nav-down-dropdown-chevron-blue.svg'
                           )
                        "
                        alt="Platforma dropdown"
                     />
                  </li>
                  <!-- Solutions Dropdown Menu - Mobile -->
                  <transition name="mobile-dropdown-animation">
                     <div v-if="openSolutionsMobileMenu" @click="resetTabM">
                        <ul class="mb-[44px]">
                           <li
                              class="flex border-b-2 border-[#F0F0F0] py-5 h-16"
                           >
                              <img
                                 class="w-[26px] mr-3"
                                 :src="
                                    $filters.media_path(
                                       'images/nav-course-creators-blue-icon.svg'
                                    )
                                 "
                                 alt="Platforma dropdown"
                              />

                              <Link
                                 href="/course-creators"
                                 class="text-[#292d34] font-bold text-sm w-full cursor-pointer"
                                 >Course Creators</Link
                              >
                           </li>
                           <li
                              class="flex border-b-2 border-[#F0F0F0] py-5 h-16"
                           >
                              <img
                                 class="w-[26px] mr-3"
                                 :src="
                                    $filters.media_path(
                                       'images/nav-influencers-blue-icon.svg'
                                    )
                                 "
                                 alt="Platforma dropdown"
                              />

                              <Link
                                 href="/influencers"
                                 class="text-[#292d34] font-bold text-sm w-full cursor-pointer"
                                 >Influencers</Link
                              >
                           </li>
                           <li
                              class="flex border-b-2 border-[#F0F0F0] py-5 h-16"
                           >
                              <img
                                 class="w-[26px] mr-3"
                                 :src="
                                    $filters.media_path(
                                       'images/nav-consultants-blue-icon.svg'
                                    )
                                 "
                                 alt="Platforma dropdown"
                              />

                              <Link
                                 href="/consultants"
                                 class="text-[#292d34] font-bold text-sm w-full cursor-pointer"
                                 >Consultants</Link
                              >
                           </li>
                           <li
                              class="flex border-b-2 border-[#F0F0F0] py-5 h-16"
                           >
                              <img
                                 class="w-[26px] mr-3"
                                 :src="
                                    $filters.media_path(
                                       'images/nav-coaches-blue-icon.svg'
                                    )
                                 "
                                 alt="Platforma dropdown"
                              />

                              <Link
                                 href="/coaches"
                                 class="text-[#292d34] font-bold text-sm w-full cursor-pointer"
                                 >Coaches</Link
                              >
                           </li>
                           <li
                              class="flex border-b-2 border-[#F0F0F0] py-5 h-16"
                           >
                              <img
                                 class="w-[26px] mr-3"
                                 :src="
                                    $filters.media_path(
                                       'images/nav-podcasters-blue-icon.svg'
                                    )
                                 "
                                 alt="Platforma dropdown"
                              />

                              <Link
                                 href="/podcasters"
                                 class="text-[#292d34] font-bold text-sm w-full cursor-pointer"
                                 >Podcasters</Link
                              >
                           </li>
                           <li
                              class="flex border-b-2 border-[#F0F0F0] py-5 h-16"
                           >
                              <img
                                 class="w-[26px] mr-3"
                                 :src="
                                    $filters.media_path(
                                       'images/nav-video-creators-blue-icon.svg'
                                    )
                                 "
                                 alt="Platforma dropdown"
                              />

                              <Link
                                 href="/video-creators"
                                 class="text-[#292d34] font-bold text-sm w-full cursor-pointer"
                                 >Video Creators</Link
                              >
                           </li>
                        </ul>
                        <!-- Platform List 2 -->
                        <a
                           class="text-[#292d34] font-bold text-sm mt-[50px] py-5"
                           >USE CASES</a
                        >

                        <ul class="mb-[44px]">
                           <li
                              class="flex border-b-2 border-[#F0F0F0] py-5 h-16 mt-5"
                           >
                              <img
                                 class="w-[26px] mr-3"
                                 :src="
                                    $filters.media_path(
                                       'images/nav-membership-sites-green-icon.svg'
                                    )
                                 "
                                 alt="Platforma dropdown"
                              />

                              <Link
                                 href="/membership-sites"
                                 class="text-[#292d34] font-bold text-sm w-full cursor-pointer"
                                 >Membership Site</Link
                              >
                           </li>
                           <li
                              class="flex border-b-2 border-[#F0F0F0] py-5 h-16"
                           >
                              <img
                                 class="w-[26px] mr-3"
                                 :src="
                                    $filters.media_path(
                                       'images/nav-programs-courses-green-icon.svg'
                                    )
                                 "
                                 alt="Platforma dropdown"
                              />

                              <Link
                                 href="programs=and=courses"
                                 class="text-[#292d34] font-bold text-sm w-full cursor-pointer"
                                 >Programs and Courses</Link
                              >
                           </li>
                           <li
                              class="flex border-b-2 border-[#F0F0F0] py-5 h-16"
                           >
                              <img
                                 class="w-[26px] mr-3"
                                 :src="
                                    $filters.media_path(
                                       'images/nav-community-green-icon.svg'
                                    )
                                 "
                                 alt="Platforma dropdown"
                              />

                              <Link
                                 href="online-communities"
                                 class="text-[#292d34] font-bold text-sm w-full cursor-pointer"
                                 >Community</Link
                              >
                           </li>
                           <li
                              class="flex border-b-2 border-[#F0F0F0] py-5 h-16"
                           >
                              <img
                                 class="w-[26px] mr-3"
                                 :src="
                                    $filters.media_path(
                                       'images/nav-lead-nurture-green-icon.svg'
                                    )
                                 "
                                 alt="Platforma dropdown"
                              />

                              <Link
                                 href="/leads-and-sales"
                                 class="text-[#292d34] font-bold text-sm w-full cursor-pointer"
                                 >Lead Nurture and Sales</Link
                              >
                           </li>
                        </ul>
                     </div>
                  </transition>
                  <!-- Pricing Link -->
                  <li class="flex mb-8" @click="resetTabM">
                     <Link href="/pricing">
                        <button class="text-[#292d34] font-bold text-lg">
                           Pricing
                        </button>
                     </Link>
                  </li>
                  <!-- Contact Sales Link -->
                  <li class="flex mb-8">
                     <button
                        class="text-[#292d34] font-bold text-lg"
                        @click="toggleContactSales"
                     >
                        Contact Sales
                     </button>
                  </li>
               </ul>
               <!-- Mobile Nav Signup - Login Buttons -->
               <div class="max-w-[600px] mx-auto">
                  <button
                     type="button"
                     @click="toggleGrabber('free', null)"
                     class="w-full h-[46px] rounded-[9px] bg-[#2d8cff] text-sm font-bold text-white duration-300 ease-in-out hover:mt-[4px] shadow-[5px_4px_20px_0_rgba(45,140,255,0.70)] mb-4"
                  >
                     Signup
                  </button>
                  <Link href="/creator/login">
                     <button
                        class="max-w-[600px] mx-auto h-[46px] w-full rounded-[9px] bg-[#E9EBF0] text-sm font-semibold text-[#292d34] duration-300 ease-in-out hover:mt-[4px]"
                     >
                        Login
                     </button>
                  </Link>
               </div>
            </nav>
         </div>
      </transition>
      <!-- nav start -->
      <div
         v-if="!toggleMobileNav"
         class="header-desktop mx-auto max-w-[1220px] lg:block"
      >
         <!-- nav -->
         <div
            class="header header-desktop__head w-full bg-white lg:bg-transparent"
         >
            <div
               class="header-desktop__head__container ease mx-auto my-0 flex h-[81px] lg:h-[100px] items-center py-0 px-2 transition-all duration-500"
            >
               <!-- logo -->
               <Link href="/" class="lg:min-w-[120px]">
                  <img
                     :src="
                        $filters.media_path(
                           'images/platforma-logo-in-color.svg'
                        )
                     "
                     alt="Platforma Online Course Builder Header Logo"
                  />
               </Link>
               <!-- center nav -->
               <div class="h-[100px] hidden lg:flex items-center">
                  <!-- products -->
                  <div
                     class="product-btn ml-10 h-[100%] cursor-pointer duration-100 ease-out hover:border-b-2 hover:border-b-[#2D8CFF]"
                     v-on:mouseover="toggleTabs(1)"
                     v-bind:class="{
                        'hover:ease-in': openTab !== 1,
                        '': openTab === 1
                     }"
                  >
                     <a
                        class="5xl:text-base flex items-center py-[40px] text-sm font-semibold text-[#292d34] duration-300 ease-in-out hover:text-[#2D8CFF]"
                        >Product
                        <i
                           v-show="openTab === 1"
                           class="product-icon fas fa-chevron-up ml-1.5 text-xs text-[#2D8CFF]"
                        ></i>
                        <i
                           v-show="openTab !== 1"
                           class="product-icon fas fa-chevron-down ml-1.5 text-xs text-[#292d34]"
                        ></i
                     ></a>
                  </div>
                  <!-- solutions -->
                  <div
                     class="solution-btn ml-10 h-[100%] cursor-pointer duration-100 ease-out hover:border-b-2 hover:border-b-[#2D8CFF]"
                     v-on:mouseover="toggleTabs(2)"
                     v-bind:class="{
                        'hover:ease-in': openTab !== 2,
                        '': openTab === 2
                     }"
                  >
                     <a
                        class="tab-underline-solutions 5xl:text-base flex items-center py-[40px] text-sm font-semibold text-[#292d34] duration-300 ease-in-out hover:text-[#2D8CFF]"
                        >Solutions<i
                           v-show="openTab === 2"
                           class="product-icon fas fa-chevron-up ml-1.5 text-xs text-[#2D8CFF]"
                        ></i>
                        <i
                           v-show="openTab !== 2"
                           class="product-icon fas fa-chevron-down ml-1.5 text-xs text-[#292d34]"
                        ></i
                     ></a>
                  </div>
                  <!-- pricing -->
                  <div class="h-[100%]">
                     <Link
                        href="/pricing"
                        class="5xl:text-base ml-10 flex h-[100%] cursor-pointer items-center text-sm font-semibold text-[#292d34] duration-300 ease-in-out hover:text-[#2D8CFF]"
                     >
                        Pricing
                     </Link>
                  </div>
               </div>
               <!-- right nav on scroll (mobile ?)-->
               <div
                  class="header-nav-right-scrollin 3xl:mr-[50px] 5xl:mr-[100px] ml-auto items-center 2xl:mr-[0px] hidden"
               >
                  <!-- contact sale -->
                  <button
                     id="sales"
                     type="button"
                     @click="toggleContactSales"
                     class="sales 5xl:text-base text-sm font-semibold text-white hidden lg:block"
                     href=""
                  >
                     Contact Sales
                  </button>
                  <!-- signup -->
                  <button
                     type="button"
                     @click="toggleGrabber('free', null)"
                     class="header-signup-button w-[101px] ml-10 lg:h-[42px] h-[45px] rounded-[9px] bg-white text-sm font-bold text-[#2D8CFF] duration-300 ease-in-out hover:mt-[4px] shadow-lg"
                  >
                     Signup
                  </button>
                  <!-- login -->
                  <Link href="/creator/login">
                     <button
                        class="header-login-button ml-3.5 h-[42px] w-[101px] rounded-[9px] bg-[rgba(198,223,255,0.12)] text-sm font-semibold text-white shadow-[0_4px_14px_0_rgba(34,85,198,0.31)] duration-300 ease-in-out hover:mt-[4px] hidden lg:block"
                     >
                        Login
                     </button>
                  </Link>
                  <!-- hamburger -->
                  <img
                     @click="toggleMobileNav = !toggleMobileNav"
                     class="cursor-pointer h-[25px] w-[23px] lg:hidden mx-6 mt-[5px]"
                     :src="
                        $filters.media_path('/images/header-hamburger-menu.svg')
                     "
                     alt="Opens up navigation for Platforma"
                  />
               </div>
               <!-- right nav  -->
               <div
                  class="header-nav-right-gettin-toggled 3xl:mr-[50px] 5xl:mr-[100px] ml-auto items-center 2xl:mr-[0px] flex"
               >
                  <!-- contact sales -->
                  <button
                     type="button"
                     @click="toggleContactSales"
                     class="cursor-pointer sales 5xl:text-base text-sm font-semibold text-white hidden lg:block"
                     v-bind:class="{
                        '': openTab !== 0,
                        ' sales-link-on-scroll': openTab === 0,
                        '': openTab !== 1,
                        ' sales-link-on-scroll': openTab === 1,
                        '': openTab !== 2,
                        'sales-link-on-scroll': openTab === 2
                     }"
                  >
                     Contact Sales
                  </button>
                  <!-- signup -->
                  <button
                     type="button"
                     @click="toggleGrabber('free', null)"
                     class="header-signup-button w-[101px] ml-10 lg:h-[42px] h-[45px] rounded-[9px] bg-white border border-[#2D8CFF] lg:border-none text-sm font-bold text-[#2D8CFF] duration-300 ease-in-out hover:mt-[4px] shadow-lg"
                     v-bind:class="{
                        '': openTab !== 0,
                        ' signup-button-on-scroll': openTab === 0,
                        '': openTab !== 1,
                        ' signup-button-on-scroll': openTab === 1,
                        '': openTab !== 2,
                        'signup-button-on-scroll': openTab === 2
                     }"
                  >
                     Signup
                  </button>
                  <!-- hamburger -->
                  <img
                     @click="toggleMobileNav = !toggleMobileNav"
                     class="cursor-pointer h-[25px] w-[23px] lg:hidden mx-6 mt-[5px]"
                     :src="
                        $filters.media_path('/images/header-hamburger-menu.svg')
                     "
                     alt="Opens up navigation for Platforma"
                  />
                  <!-- login -->
                  <Link href="/creator/login">
                     <button
                        v-bind:class="{
                           '': openTab !== 0,
                           ' login-button-on-scroll': openTab === 0,
                           '': openTab !== 1,
                           ' login-button-on-scroll': openTab === 1,
                           '': openTab !== 2,
                           'login-button-on-scroll': openTab === 2
                        }"
                        class="header-login-button ml-3.5 h-[42px] w-[101px] rounded-[9px] bg-[rgba(198,223,255,0.12)] text-sm font-semibold text-white shadow-[0_4px_14px_0_rgba(34,85,198,0.31)] duration-300 ease-in-out hover:mt-[4px] hidden lg:block"
                     >
                        Login
                     </button>
                  </Link>
               </div>
            </div>
         </div>
      </div>
   </header>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import EmailGrabberPopup from '../Components/EmailGrabberPopup.vue';
import ContactSalesPopup from '../Components/ContactSalesPopup.vue';

const openTab = ref(0);
const openProductMobileMenu = ref(false);
const openSolutionsMobileMenu = ref(false);
const toggleMobileNav = ref(false);
const contactSalesActive = ref(false);
const grabberActive = ref(false);
const freePlan = ref(false);
const payPlan = ref(false);
const planId = ref(null);
// const close;
// let observer = null;
// let section1 = null;

const toggleTabs = (tabNumber) => {
   openTab.value = tabNumber;
};

const toggleContactSales = () => {
   contactSalesActive.value = !contactSalesActive.value;
};

const toggleGrabber = (plan, id) => {
   if (plan === 'free') {
      freePlan.value = true;
      payPlan.value = false;
      planId.value = null;
   }
   if (plan === 'pay') {
      payPlan.value = true;
      planId.value = id;
      freePlan.value = false;
   }
   grabberActive.value = !grabberActive.value;
};

const resetTab = () => {
   openTab.value = 0;
   // toggleMobileNav.value = !toggleMobileNav.value;
};

const resetTabM = () => {
   // openTab.value = 0;
   toggleMobileNav.value = !toggleMobileNav.value;
};

onMounted(() => {
   const header = document.querySelector('#header');
   const productNavDesktop = document.querySelector('.product-nav-desktop');
   const headerNavRightScrollin = document.querySelector(
      '.header-nav-right-scrollin'
   );
   const headerNavRightTogglin = document.querySelector(
      '.header-nav-right-gettin-toggled'
   );
   const sales = document.querySelector('.sales');
   const signButton = document.querySelector('.header-signup-button');
   const loginButton = document.querySelector('.header-login-button');

   if (header) {
      window.addEventListener('scroll', navbarChange);
      window.addEventListener('load', navbarChange);

      function navbarChange() {
         if (window.pageYOffset > 20) {
            header.classList.add(
               'bg-white',
               'drop-shadow-[0_35px_35px_rgba(0,0,0,0.10)]'
            );
            productNavDesktop.classList.add('bg-black');
            sales.classList.add('sales-link-on-scroll');
            headerNavRightScrollin.classList.remove('hidden');
            headerNavRightScrollin.classList.add('flex');
            headerNavRightTogglin.classList.add('hidden');
            headerNavRightTogglin.classList.remove('flex');
            signButton.classList.add('signup-button-on-scroll');
            loginButton.classList.add('login-button-on-scroll');
         } else {
            header.classList.remove(
               'bg-white',
               'drop-shadow-[0_35px_35px_rgba(0,0,0,0.10)]'
            );
            headerNavRightScrollin.classList.add('hidden');
            headerNavRightScrollin.classList.remove('flex');
            headerNavRightTogglin.classList.remove('hidden');
            headerNavRightTogglin.classList.add('flex');
            sales.classList.remove('sales-link-on-scroll');
            signButton.classList.remove('signup-button-on-scroll');
            loginButton.classList.remove('login-button-on-scroll');
         }
      }
   }
});
</script>

<style scoped>
.sales-link-on-scroll {
   color: #292d34;
}

.signup-button-on-scroll {
   background: #2d8cff;
   color: #fff;
}
.login-button-on-scroll {
   background: #fff;
   color: #292d34;
}

/* Mobile Menu Slide Transition */

.mobile-animation-enter-active {
   animation: moveRightMobileNav 0.3s ease-in;
}
.mobile-animation-leave-active {
   animation: leaveRightMobileNav 0.3s ease-in;
}

/* Desktop Menu Slide Transitions */

.desktop-animation-enter-active {
   animation: desktopNavDropdown 0.5s ease-in;
   transition: opacity 0.7s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}

.desktop-animation-leave-to {
   animation: desktopNavDropup 0.5s ease-in;
   transition: opacity 0.7s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}

.desktop-animation-enter-from,
.desktop-animation-leave-to {
   opacity: 0;
}
/* Desktop Menu Inner List Transitions*/

.desktop-menu-list-enter-active {
   transition: opacity 0.8s cubic-bezier(0.52, 0.02, 0.19, 1.02) 0.45s;
}
.desktop-menu-list-leave-active {
   transition: opacity 0.8s cubic-bezier(0.52, 0.02, 0.19, 1.02) 0.45s;
}

.desktop-menu-list-enter-from {
   opacity: 0;
}

/* Desktop Menu Inner List Items Transitions*/
.desktop-menu-item-enter-active,
.desktop-menu-item-leave-active {
   transition: opacity 0.7s cubic-bezier(0.52, 0.02, 0.19, 1.02) 0.75s;
}

/* .desktop-menu-item-enter-from,
.desktop-menu-item-leave-to {
  opacity: 0;
  animation: moveRightMobileNav 0.3s ease-in;
} */

/* Mobile Menu Slide Transition Keyframes */

@keyframes moveRightMobileNav {
   0% {
      transform: translateX(120%);
   }

   100% {
      transform: translateX(0);
   }
}
@keyframes leaveRightMobileNav {
   100% {
      transform: translateX(120%);
   }

   0% {
      transform: translateX(0);
   }
}

/* Desktop Menu Slide Transition Keyframes */

@keyframes desktopNavDropdown {
   0% {
      transform: translateY(-120%);
   }

   100% {
      transform: translateY(0);
   }
}

@keyframes desktopNavDropup {
   100% {
      transform: translateY(-120%);
   }

   0% {
      transform: translateY(0);
   }
}
</style>
